<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a date picker object that can be used within a form
    *
    * @since 20200414
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <span>
        <vc-date-picker class="flex-grow"
            v-model="calendar_date" 
            v-on:input="update_value($event)"
            :mode="type" 
        >
            <template v-slot="{ inputValue, inputEvents }">
                <input
                    class="form-control"
                    :value="inputValue"
                    v-on="inputEvents"
                />
            </template>
        </vc-date-picker>
       <input :name='name' type='hidden' :value='nice_date' />
       <!--   <vc-date-picker 
            mode="single"
            v-model="calendar_date"
            :value="calendar_date"
            v-on:input="update_value($event)"
            :input-props="date_props"
        />  -->
    </span>
</template>

<script>
    export default{
        props: {
            //the name of the date picker
            name: {
                type: String,
                default: ''
            },
            //the defalt date value if year/month/day not provided
            value: {
                default: ''
            },
            //the default year
            year: {
                type: String,
                default: ''
            },
            //the default month
            month: {
                type: String,
                default: ''
            },
            //the default day
            day: {
                type: String,
                default: ''
            },
            //the input props
            input_props: {
                type: Object,
                default: () => {}
            },
            //the class of the input
            date_class: {
                type: String,
                default: 'form-control'
            },
            changeAcademicYear: {
                type: Boolean,
                default: false
            },
            type: {
                type: String,
                default: 'date'
            },
        },
        created() {
            if(this.year.length > 0 && this.month.length > 0 && this.day.length > 0){
                this.calendar_date = new Date(this.year, this.month-1, this.day);
                this.startVal = new Date(this.calendar_date.getTime());
            } else if(this.value !== null && this.value.length > 0) {
                this.calendar_date = new Date(this.value);
                if(this.calendar_date.toString() == 'Invalid Date'){
                    var arr = this.value.split('-');
                    if(arr.length == 3){
                        this.calendar_date = new Date(arr[0], arr[1]-1, arr[2].substr(0, 2));
                    }
                    arr = this.value.split('/');
                    if(arr.length == 3){
                        this.calendar_date = new Date(arr[2].substr(0, 4), arr[1]-1, arr[0]);
                    }
                }
                this.startVal = new Date(this.calendar_date.getTime());
            } else if(this.value !== null && typeof this.value.getMonth === 'function'){
                //if a date object
                this.calendar_date = new Date(this.value);
                console.log(this.calendar_date);
            }
        },
        mounted() {
            this.$emit('input', this.nice_date);
        },
        data() {
            return {
                //the date
                calendar_date: null,
                first_update: true,
                startVal: null
            }
        },
        computed: {
            /**
             * returns the date in a nice format that can be sent in the form
             * 
             * @return String the formatted date
             */
            nice_date: function() {
                //for some reason, when adding in a date a after british summer time starts, the time zone goes weird, so removing timezone offset
                if(this.calendar_date != null){
                    //formatting the date into a format that Carbon Date recognises. JSON.stringfy does that, but requires it to be in an array or struct for it to work, so remove array bit afterwards
                    var json_date = JSON.stringify([new Date(this.calendar_date.getTime() - (this.calendar_date.getTimezoneOffset() * 60000))]);
                    return json_date.substring(2, json_date.length-2);
                } else {
                    return null;
                }
            },
            /**
             * returns the input props plus the class
             * @returns Object the props
             */
            date_props: function() {
                var ret = {};
                if(this.input_props !== undefined){
                    var ret = this.input_props;
                }
                if(this.date_class.length > 0){
                    ret.class = this.date_class;
                }
                return ret;
            }
        },
        methods: {
            setDate: function(dt){
                if(dt === undefined || dt === null){
                    this.calendar_date = null;
                } else {
                    this.calendar_date = new Date(dt);
                }
                this.$emit('input', this.nice_date);
            },
            /**
             * updates the model of the editor to the current value
             * @param String value the value of the editor
             */
            update_value: function (value) {
                var val = value;
                if(value !== undefined && value !== null && value.target !== undefined && value.target.value !== undefined){
                    val = value.target.value;
                }
                this.calendar_date = val;
                var sameVal = false;
                if(this.calendar_date == null || this.startVal == null){
                    sameVal = this.calendar_date == this.startVal;
                } else {
                    sameVal = this.calendar_date.toString() == this.startVal.toString();
                }
                
                //console.log(this.calendar_date.toString());
                //console.log(this.startVal.toString());
                if(!this.first_update || !sameVal){
                    this.$emit('input', this.nice_date);
                }
                if(this.changeAcademicYear){
                    if(this.calendar_date == null){
                        this.$searchDateAcademicYearId = -1;
                    } else {
                        this.$searchDateAcademicYearId = (this.calendar_date.getMonth() < 7) ? this.calendar_date.getFullYear()-1 : this.calendar_date.getFullYear();
                    }
                }
                this.first_update = false;
            },
        }
    }
</script>